export const adiquimica = {
  // Adiquimica Discrepancy
  adiquimica_discrepancy_po_empty:
    "No se encontró una orden de compra (PO) para el número de seguimiento: {{0}}.",

  adiquimica_discrepancy_invoice_po_not_found:
    "La factura con número de seguimiento {{0}} no tiene una orden de compra coincidente con el número {{1}}.",

  adiquimica_discrepancy_dn_po_not_found:
    "La nota de entrega con número de documento {{0}} no tiene una orden de compra coincidente con el número {{1}}.",

  adiquimica_discrepancy_invoice_po_amount_not_match:
    "El monto total de la factura {{2}} para el documento {{0}} con número de PO {{1}} no coincide con el monto total de la PO {{3}}.",

  adiquimica_discrepancy_invoice_po_amountwithouttax_not_match:
    "El monto sin impuestos de la factura {{2}} para el documento {{0}} y la PO número {{1}} no coincide con el monto sin impuestos de la PO {{3}}.",

  adiquimica_discrepancy_no_items: "No se encontraron artículos.",

  adiquimica_discrepancy_item_adiquimicaitem_empty:
    'El artículo de la Orden de Compra "{{0}}" con la descripción "{{1}}" no tiene un artículo coincidente en la factura.',

  adiquimica_discrepancy_item_po_item_matching_notfound:
    'El artículo de la factura n.º {{0}} con la descripción "{{1}}" no tiene un artículo coincidente en la Orden de Compra.',

  adiquimica_discrepancy_item_po_mismatch:
    'El artículo "{{1}}" en el índice {{0}} tiene una discrepancia en el número de PO: el PO del documento es {{2}}, pero el número de PO del artículo es {{3}}.',

  adiquimica_discrepancy_item_unitprice_mismatch:
    'El precio unitario del artículo "{{1}}" en el índice {{0}} es "{{2}}", lo cual no coincide con el precio unitario en la PO de {{3}}.',

  adiquimica_discrepancy_item_amount_mismatch:
    'El monto del artículo "{{1}}" en el índice {{0}} es {{2}}, lo cual no coincide con el monto base de la PO {{3}} (calculado como Precio Neto × Cantidad).',

  adiquimica_discrepancy_item_quantity_mismatch:
    'La cantidad del artículo "{{1}}" en el índice {{0}} es {{2}}, lo cual no coincide con la cantidad en la PO de {{3}}.',

  adiquimica_discrepancy_itemamount_shouldbe_between_8and10: `El importe del artículo "{{1}}" debe estar entre 8 y 12; se encontró {{2}}.`,

  adiquimica_discrepancy_itemunitprice_shouldbe_between_8and10: `El precio unitario del artículo "{{1}}" debe estar entre 8 y 12; se encontró {{2}}.`,

  adiquimica_currency_missmatch:
    'Desajuste de moneda. Moneda esperada: "€" pero se encontró {{0}}.',
  adiquimica_description_contains_proyecto:
    'La descripción "{{0}}" contiene la palabra "proyecto".',
  adiquimica_item_vatcode_cc:
    "Código de IVA no válido para el ítem del PO de Adiquimica en la fila #{{0}}.",
  adiquimica_item_vatcode_0:
    "Código de IVA faltante para el ítem del PO de Adiquimica en la fila #{{0}}.",
  adiquimica_ponumber_mustbe_8characters:
    'El número de pedido "{{0}}" debe tener 8 caracteres',
  adiquimica_dn_po_not_attached: `La Nota de Entrega no está adjunta, referenciada en la Factura '#{{0}}.'`,
  adiquimica_delivery_note_not_found: `La Nota de Entrega '#{{0}}' no fue encontrada en la Factura '#{{2}}'.`,
  adiquimica_invoice_item_count_miss_match: `La cantidad de artículos en la Factura '#{{2}}' no coincide con la cantidad de artículos en la Nota de Entrega '#{{0}}'.`,
  adiquimica_delivery_note_delivery_date_missing: `La fecha de entrega (FechaEntrega) está vacía en la Nota de Entrega '#{{0}}' referenciada en la Factura '#{{2}}'. Complétela en la Nota de Entrega y vuelva a procesar la Factura.`,
};
